import React, { ReactElement } from 'react';

export default function SmallCogIcon({ className }: { className: string }): ReactElement {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.985 22.999" className={className}>
            <g transform="translate(-16.507 -186.5)">
                <path
                    id="star-solid"
                    d="M30.759.753,27.954,6.441l-6.277.915a1.375,1.375,0,0,0-.76,2.346l4.541,4.425-1.074,6.251a1.374,1.374,0,0,0,1.993,1.448l5.615-2.952,5.615,2.952A1.375,1.375,0,0,0,39.6,20.378l-1.074-6.251L43.068,9.7a1.375,1.375,0,0,0-.76-2.346L36.03,6.441,33.225.753A1.376,1.376,0,0,0,30.759.753Z"
                    transform="translate(-3.492 187.013)"
                    fill="#ebbe29"
                />
                <path
                    id="star-solid_-_Outline"
                    data-name="star-solid - Outline"
                    d="M31.989-.513h0A1.868,1.868,0,0,1,33.673.531l2.69,5.453,6.017.877a1.875,1.875,0,0,1,1.037,3.2L39.064,14.3l1.03,5.992a1.835,1.835,0,0,1-.408,1.517,1.886,1.886,0,0,1-1.443.675,1.85,1.85,0,0,1-.869-.217l-5.382-2.829-5.383,2.829a1.842,1.842,0,0,1-.87.219,1.883,1.883,0,0,1-1.44-.675,1.837,1.837,0,0,1-.409-1.519L24.92,14.3,20.567,10.06a1.875,1.875,0,0,1,1.038-3.2l6.016-.877L30.311.531A1.861,1.861,0,0,1,31.989-.513Zm6.254,22a.9.9,0,0,0,.678-.32.85.85,0,0,0,.186-.7l-1.119-6.51,4.73-4.609a.876.876,0,0,0-.483-1.493L35.7,6.9,32.777.974a.862.862,0,0,0-.788-.486h0a.856.856,0,0,0-.781.487L28.286,6.9l-6.537.953a.875.875,0,0,0-.484,1.493l4.73,4.609-1.119,6.51a.852.852,0,0,0,.187.7.9.9,0,0,0,.676.319.854.854,0,0,0,.4-.1l5.849-3.075,5.848,3.074A.86.86,0,0,0,38.243,21.485Z"
                    transform="translate(-3.492 187.013)"
                    fill="#dfb93a"
                />
            </g>
        </svg>
    );
}
